<template>
  <div class="platform">
    <com-title title="我们的营销平台" subtitle="覆盖1000万+中高端技术人员"></com-title>
    <div class="section-tech container">
      <div class="section-media">
        <h3 class="title">技术媒体</h3>
        <ul class="content columns">
          <li class="item column" v-for="(item, index) in medias" :key="index">
            <a :href="item.link">
              <img :src="item.img" alt="">
              <span class="name">{{item.name}}</span>
              <span class="slogan">{{item.slogan}}</span>
            </a>
            <!-- <span class="line" v-if="index===0"></span> -->
          </li>
        </ul>
      </div>
      <div class="section-video" v-if="!isMobile">
        <h3 class="title">视频品牌</h3>
        <ul class="content columns">
          <li class="item column" v-for="(item, index) in videosM" :key="index">
            <a :href="item.link">
              <img :src="item.img" alt="">
              <span class="name">{{item.name}}</span>
              <span class="slogan">{{item.slogan}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="section-video mobile" v-if="isMobile">
        <h3 class="title">视频品牌</h3>
        <ul class="content columns">
          <li class="item column" v-for="(item, index) in videosM" :key="index">
            <a :href="item.link">
              <img :src="item.img" alt="">
              <div class="right">
                <span class="name">{{item.name}}</span>
                <span class="slogan">{{item.slogan}}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="section-wechat container">
      <h3>垂直公众号</h3>
      <ul class="columns is-mobile">
        <li class="column is-half-mobile" v-for="(item, index) in wechats" :key="index">
          <div class="wrap">
            <img :src="item.img" alt="">
            <div class="title">{{item.title}}</div>
            <div class="intro">
              <img :src="item.qcode" alt="">
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="section-conf container">
      <h3>技术大会</h3>
      <ul class="columns is-mobile">
        <li class="column is-one-third-desktop" v-for="(item, index) in confs" :key="index">
          <a :href="item.link" target="_blank">
            <img :src="item.img" alt="">
            <div class="title">{{item.title}}</div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/title'
import { mapState } from 'vuex'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),
    medias () {
      return [{
        link: 'http://www.infoq.com/cn',
        img: 'http://static.geekbang.org/infoq/5a227145bf6fe.png?imageView2/0/',
        name: 'InfoQ 网站',
        slogan: '促进软件开发领域知识与创新的传播'
      }, {
        link: 'https://mp.weixin.qq.com/s?__biz=MjM5MDE0Mjc4MA==&mid=403497762&idx=1&sn=65d6f79514f05c55e1ba39b942f3f486&scene=1&srcid=0413QkgmFlRoTce6MTT3mgXc&key=b28b03434249256b8ebb782d8fe9881a299d061cc5e51745f2fd0f3ce29e3c39ac3098310bf916eff71762ac2bd7d626&ascene=0&uin=NjQzNzkyMTIw&devicetype=iMac+MacBookAir6%2C2+OSX+OSX+10.11.4+build(15E65)&version=11020201&pass_ticket=ZiR0bH1PXK1r8wLXHIG5wmRoJbfCzjGvc7AgBbfBslTgvRyYD%2FCrL9TWkAy1j%2BO6',
        img: 'http://static.geekbang.org/infoq/5a227145780fd.png?imageView2/0/',
        name: 'InfoQ 公众号',
        slogan: '有内容的技术社区媒体'
      }]
    },
    videosM () {
      return [{
        link: 'https://live.geekbang.org/video',
        img: 'http://static.geekbang.org/infoq/5a2272127536b.png?imageView2/0/w/120',
        name: '二叉树',
        slogan: '记录与时代并行的技术人'
      }]
    },
    wechats () {
      return [{
        qcode: 'http://static.geekbang.org/infoq/5a24c97db40d0.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a227404a7919.png?imageView2/0/',
        title: '高效开发运维'
      }, {
        qcode: 'http://static.geekbang.org/infoq/5a24c97b7fa5c.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a2274050ef7a.png?imageView2/0/',
        title: '聊聊架构'
      }, {
        qcode: 'http://static.geekbang.org/infoq/5a24c97e4c7df.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a227403aacd3.png?imageView2/0/',
        title: '前端之巅'
      }, {
        qcode: 'http://static.geekbang.org/infoq/5a24c97bc648c.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a227405760a8.png?imageView2/0/',
        title: '细说云计息'
      }, {
        qcode: 'http://static.geekbang.org/infoq/5a24c97ca7311.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a22740447de0.png?imageView2/0/',
        title: '移动开发前线'
      }, {
        qcode: 'http://static.geekbang.org/infoq/5a24c97d04b73.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a227403dfb95.png?imageView2/0/',
        title: 'AI前线'
      }]
    },
    confs () {
      return [{
        link: 'http://qconshanghai.com/',
        img: 'https://static.geekbang.org/infoq/5a30c4456f54a.png?imageView2/0/',
        title: 'QCon 全球软件开发大会'
      }, {
        link: 'http://archsummit.com/',
        img: 'https://static.geekbang.org/infoq/5a30c4467f55e.png?imageView2/0/',
        title: 'ArchSummit 全球架构师峰会'
      }, {
        link: 'http://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5a30c5218bd94.png?imageView2/0/',
        title: 'AICon 全球人工智能技术大会'
      }, {
        link: 'http://www.cnutcon.com/',
        img: 'https://static.geekbang.org/infoq/5a30c445b58ab.png?imageView2/0/',
        title: 'CNUTCon 全球运维技术大会'
      }, {
        link: 'http://gmtc.geekbang.org/',
        img: 'https://static.geekbang.org/infoq/5a30c4449e366.png?imageView2/0/',
        title: 'GMTC 全球移动技术大会'
      }, {
        link: 'http://gtlc.geekbang.org/',
        img: 'https://static.geekbang.org/infoq/5a30c445ee5bf.png?imageView2/0/',
        title: 'GTLC 全球技术领导力峰会'
      }]
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/variable.sass'

h3
  color: #353535
  font-size: 23px
  margin-bottom: 10px
+mobile
  .container
    width: 88vw

div.platform
  background-color: #f7f8f8
  padding-bottom: 60px
  +mobile
    // padding: 1.7rem
    padding-bottom: 0
  .section-tech
    display: flex
    padding-bottom: 40px
    +mobile
      flex-direction: column
      padding: 0
    .section-media,.section-video
      margin-right: 20px
      flex-grow: 2
      +mobile
        margin-right: 0
        margin: 15px 0
      .content
        background-color: #fff
        box-shadow: 0 4px 15px 0 rgba(7,17,27,.1)
        padding: 38px 0
        display: flex
        margin: 0
        +mobile
          padding: 20px 0
        .item
          display: flex
          justify-content: center
          align-items: center
          position: relative
          a
            display: flex
            flex-direction: column
            text-align: center
            img
              width: 100px
              margin: 0 auto
              margin-bottom: 15px
            .name
              color: #353535
              margin-bottom: 4px
            .slogan
              color: #888
              font-size: 12px
              width: 80%
              margin: 0 auto
          .line
            position: absolute
            right: 0
            width: 2px
            height: 150px
            background-color: #e6e6e6
    .section-video
      flex-grow: 1
      margin-right: 0
    .section-video.mobile
      .content
        .item
          a
            display: flex
            flex-direction: row
            align-items: center
            text-align: left
            img
              margin: 0
              margin-right: 30px
            .right
              display: flex
              flex-direction: column
              .slogan
                margin-left: 0

  .section-wechat
    +mobile
     margin-top: 15px
    ul
      +mobile
        flex-wrap: wrap
      li
        +mobile
          margin-right: 0px
          justify-content: space-between
        .wrap
          padding: 30px 0
          background-color: #fff
          box-shadow: 0 4px 15px 0 rgba(7,17,27,.1)
          text-align: center
          position: relative
          overflow: hidden
          &:hover
            .intro
              top: 0
          .intro
            position: absolute
            width: 100%
            height: 100%
            background-color: rgba(38, 75, 111, 1)
            color: #fff
            top: -100%
            transition: 0.5s
            display: flex
            justify-content: center
            align-items: center
        &:last-child
          margin-right: 0
        img
          width: 60%
          margin-bottom: 15px
        .title
          +mobile
            font-size: 14px
  .section-conf
    padding: 40px 0
    .columns
      flex-wrap: wrap
      justify-content: space-between
      margin: 0
      +mobile
        flex-direction: column
      li
        width: 32.2%
        text-align: center
        background-color: #fff
        box-shadow: 0 4px 15px 0 rgba(7,17,27,.1)
        margin-bottom: 20px
        padding: 1.5rem
        a
          img
            width: 80%
        +mobile
          width: auto
</style>
